package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * A segmented password-strength meter: [total] equal-width bars of which the first [filled] are tinted
 * [color] and the rest sit on the surface track, with a [label] describing the level. Data-agnostic —
 * the caller maps its own strength model to (filled, color, label), so the DS carries no scoring or
 * copy. Render nothing when the field is empty (filled == 0 with no label).
 */
@Composable
fun PasswordStrengthMeter(
    filled: Int,
    total: Int,
    color: Color,
    label: String,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
            repeat(total) { index ->
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .height(AppTheme.sizes.strengthBar)
                        .clip(AppTheme.shapes.pill)
                        .background(if (index < filled) color else AppTheme.colors.surfaceContainer),
                )
            }
        }
        Text(text = label, style = AppTheme.typography.bodySm, color = color)
    }
}
